import { render, staticRenderFns } from "./FundModal.vue?vue&type=template&id=b5aa7f48&"
import script from "./FundModal.vue?vue&type=script&lang=js&"
export * from "./FundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports